var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowLeftCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M12 22C6.485 22 2 17.514 2 12C2 6.486 6.485 2 12 2C17.514 2 22 6.486 22 12C22 17.514 17.514 22 12 22",
    fill: "#75759E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.442 16.2211C13.251 16.2211 13.059 16.1481 12.913 16.0021L9.42603 12.5321C9.28503 12.3911 9.20603 12.2001 9.20603 12.0001C9.20603 11.8011 9.28503 11.6101 9.42603 11.4691L12.913 7.99707C13.206 7.70507 13.68 7.70507 13.973 7.99907C14.265 8.29307 14.264 8.76807 13.971 9.06007L11.018 12.0001L13.971 14.9401C14.264 15.2321 14.265 15.7061 13.973 16.0001C13.827 16.1481 13.634 16.2211 13.442 16.2211",
    fill: "#75759E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftCircle);
export default __webpack_public_path__ + "static/media/arrow-left-circle.b03c7040224f4f00cb0f4446d70e3b84.svg";
export { ForwardRef as ReactComponent };